module.exports = __webpack_public_path__ + "img/upload-file-circle.5d485dc8.svg";